import { render, staticRenderFns } from "./StudentsPage.vue?vue&type=template&id=1905c0d4&scoped=true"
import script from "./StudentsPage.vue?vue&type=script&lang=js"
export * from "./StudentsPage.vue?vue&type=script&lang=js"
import style0 from "./StudentsPage.vue?vue&type=style&index=0&id=1905c0d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905c0d4",
  null
  
)

export default component.exports